import { useMutation } from "react-query";

import type { CancellationRequestBody } from "@jti/rest-api-types";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { OrderCancellationApi } from "../../../services/orderCancellation/orderCancellationApi";

export const useOrderCancellation = () => {
  const mutation = useMutation({
    mutationKey: [MUTATION_KEYS.orderCancellation],
    mutationFn: async (data: CancellationRequestBody) => {
      const orderCancellationApi = new OrderCancellationApi();
      return orderCancellationApi.sendCancellationRequest(data);
    },
    onError: (error) => {
      console.error("[useOrderCancellation]: Order cancellation request failed:", error);
    },
  });

  return mutation;
};
